import { Directive, Input, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: 'ng-template[khCarouselSlide]',
  standalone: false
})
export class CarouselSlideDirective {
  private readonly template = inject(TemplateRef<unknown>);

  @Input() public id?: string;

  public get templateRef(): TemplateRef<unknown> {
    return this.template;
  }
}
